import padWithZero from './padWithZero';

/**
 * Formats a provided time in seconds into a human readable time string
 * (e.g. 01:22:33), optionally including minutes, and hours.
 */

const getHumanReadableTime = (
    totalSeconds: number,
    renderMinutes = true,
    renderHours = false
): string => {
    const segments = [];

    totalSeconds = totalSeconds === Infinity ? 0 : totalSeconds;

    const seconds = parseInt((totalSeconds % 60).toString());
    const minutes = parseInt((totalSeconds / 60).toString()) % 60;
    const hours   = parseInt((totalSeconds / 3600).toString()) % 24;

    segments.unshift(padWithZero(seconds));

    if (renderMinutes) {
        segments.unshift(padWithZero(minutes));

        if (renderHours) {
            segments.unshift(padWithZero(hours));
        }
    }

    return segments.join(':');
};

export default getHumanReadableTime;